// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"addPhoto__gradient-bg5__jl5Ms","buttonWrapper":"addPhoto__buttonWrapper__v2n4V","editBtn":"addPhoto__editBtn__Soa1Z","deleteBtn":"addPhoto__deleteBtn__OOt8x"};